import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'

// 登录方法
export function login(username, password, code, uuid, phone, deviceType) {
  const data = {
    username,
    password,
    code,
    uuid,
    phone,
    deviceType
  }
  return request({
    url: `/${systemConfig.authPrefix}/login`,
    method: 'post',
    data: data
  })
}

// 登录方法
export function loginBySms(phone, code) {
  const data = {
    phone,
    code
  }
  return request({
    url: `/${systemConfig.sysPrefix}/loginBySms`,
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: `/${systemConfig.authPrefix}/getInfo`,
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: `/${systemConfig.authPrefix}/logout`,
    method: 'post'
  })
}

//获取手机号
export function getPhone(data) {
  return request({
    url: `/${systemConfig.authPrefix}/loginVerifyUser`,
    method: 'post',
    data: data
  })
}

//获取短信验证码
export function getSmsCode(data) {
  return request({
    url: `/${systemConfig.authPrefix}/loginSendPhoneCode`,
    method: 'post',
    data: data
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: `/${systemConfig.authPrefix}/captchaImage`,
    method: 'get'
  })
}

export function sendLoginSmsCode(data) {
  return request({
    url: `/${systemConfig.sysPrefix}/sms/sendLoginSmsCode`,
    method: 'post',
    data: data
  })
}

// 获取路由
export const getRouters = () => {
  return request({
    url: `/${systemConfig.sysPrefix}/getRouters`,
    method: 'get'
  })
}

